/* eslint-disable camelcase */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-plusplus */
import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactLoading from "react-loading";
import { useState } from "react";
import PropTypes from "prop-types";

export default function AlertDialog({
  ItemNumber1,
  ItemArray,
  photo,
  desc1,
  desc2,
  category,
  ctn,
  qtytoctn,
  totoqty,
  utoprice,
  amount,
  cbm,
  ttocbm,
  nw,
  gw,
  status,
  notes,
  shop_number1,
  shop_number2,
  total_amount1,

  phone_number,
  customer_id,
  container_id,
  delivery_date,
  order_number,
}) {
  AlertDialog.propTypes = {
    ItemNumber1: PropTypes.instanceOf(Array).isRequired,
    ItemArray: PropTypes.instanceOf(Array).isRequired,
    photo: PropTypes.objectOf(PropTypes.any).isRequired,
    desc1: PropTypes.instanceOf(Array).isRequired,
    desc2: PropTypes.instanceOf(Array).isRequired,
    category: PropTypes.instanceOf(Array).isRequired,
    ctn: PropTypes.instanceOf(Array).isRequired,
    qtytoctn: PropTypes.instanceOf(Array).isRequired,
    totoqty: PropTypes.instanceOf(Array).isRequired,
    utoprice: PropTypes.instanceOf(Array).isRequired,
    amount: PropTypes.instanceOf(Array).isRequired,
    cbm: PropTypes.instanceOf(Array).isRequired,
    ttocbm: PropTypes.instanceOf(Array).isRequired,
    nw: PropTypes.instanceOf(Array).isRequired,
    gw: PropTypes.instanceOf(Array).isRequired,
    status: PropTypes.instanceOf(Array).isRequired,
    notes: PropTypes.instanceOf(Array).isRequired,
    shop_number1: PropTypes.string.isRequired,
    shop_number2: PropTypes.string.isRequired,
    total_amount1: PropTypes.string.isRequired,

    phone_number: PropTypes.string.isRequired,
    customer_id: PropTypes.string.isRequired,
    container_id: PropTypes.string.isRequired,
    delivery_date: PropTypes.string.isRequired,
    order_number: PropTypes.string.isRequired,
  };

  const [dialogsucesss, setOpen1] = React.useState(false);
  const [dialogempty, setOpen2] = React.useState(false);
  const [dialogloading, setOpen3] = React.useState(false);
  const handleClickOpenLoading = () => {
    setOpen3(true);
  };
  const handleCloseLoading = () => {
    setOpen3(false);
  };
  const { t } = useTranslation();

  const handleClickOpenSuccess = () => {
    setOpen1(true);
  };
  const handleClickOpenEmpty = () => {
    setOpen2(true);
  };

  const handleCloseSuccess = () => {
    setOpen1(false);
  };
  const handleCloseEmpty = () => {
    setOpen2(false);
  };

  const [shoponeArray, setshoponeArray] = useState([1, 2, 5, 6, 6, 4, 4]);
  // const [name, setName] = useState([]);
  // const onNameChange = (e, index) => {
  //   setName((state) => {
  //     return state.map((el, index1) =>
  //        index === index1 ? e.target.value : el;)

  //   });
  // };
  function addOrderTest() {
    const formdata = new FormData();
    formdata.append("delivery_date", delivery_date);
    formdata.append("phone_number", phone_number);
    formdata.append("order_code", order_number);
    formdata.append("customer_id", customer_id);
    formdata.append("container_id", container_id);
    ItemArray.map((item, index) => formdata.append(`our_item[${index}]`, ItemArray[index]));
    ItemNumber1.map((item, index) => formdata.append(`item_number[${index}]`, ItemNumber1[index]));
    photo.map((item, index) => formdata.append(`photo[${index}]`, photo[index]));
    desc1.map((item, index) => formdata.append(`description1[${index}]`, desc1[index]));
    desc2.map((item, index) => formdata.append(`description2[${index}]`, desc2[index]));
    category.map((item, index) => formdata.append(`category[${index}]`, category[index]));
    ctn.map((item, index) => formdata.append(`ctn[${index}]`, ctn[index]));
    amount.map((item, index) => formdata.append(`amount[${index}]`, amount[index]));
    cbm.map((item, index) => formdata.append(`cbm[${index}]`, cbm[index]));
    status.map((item, index) => formdata.append(`status[${index}]`, status[index]));
    notes.map((item, index) => formdata.append(`notes[${index}]`, notes[index]));
    qtytoctn.map((item, index) => formdata.append(`qty_ctn[${index}]`, qtytoctn[index]));
    totoqty.map((item, index) => formdata.append(`t_qty[${index}]`, totoqty[index]));
    utoprice.map((item, index) => formdata.append(`u_price[${index}]`, utoprice[index]));
    ttocbm.map((item, index) => formdata.append(`t_cbm[${index}]`, ttocbm[index]));
    nw.map((item, index) => formdata.append(`n_w[${index}]`, nw[index]));
    gw.map((item, index) => formdata.append(`gw[${index}]`, gw[index]));
    totoqty.map((item, index) => formdata.append(`t_qty[${index}]`, totoqty[index]));

    const headers = { ContentType: `application/json` };
    const url = "https://trust-cargo.co/anas_backend/api/add_order";

    axios
      .post(url, formdata, headers)
      .then((response) => {
        // console.log("success");
        // console.log(formData);
        handleCloseLoading();
        handleClickOpenSuccess();
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  const navigate = useNavigate();
  return (
    <div>
      <Button
        variant="contained"
        style={{ color: "white", marginTop: "20px" }}
        onClick={() => {
          handleClickOpenLoading();
          if (document.getElementById("shop_no1").value === "") {
            handleCloseLoading();
            handleClickOpenEmpty();
          } else {
            addOrderTest();
          }
        }}
      >
        Add Order
      </Button>
      <Dialog
        open={dialogsucesss}
        onClose={handleCloseSuccess}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">تم اضافه الطلبيه بنجاح</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous location data to
            Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          {/* navigate("/add_user"); */}
          {/* <Button onClick={handleClose}>ok</Button> */}
          <Button
            onClick={() => {
              navigate("/orders");
            }}
            autoFocus
          >
            {t("ok")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogempty}
        onClose={handleCloseEmpty}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{t("add_lab_empty")}</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            Let Google help apps determine location. This means sending anonymous location data to
            Google, even when no apps are running.
          </DialogContentText> */}
        </DialogContent>
        <DialogActions>
          {/* <Button onClick={handleClose}>ok</Button> */}
          <Button onClick={handleCloseEmpty} autoFocus>
            {t("ok!!")}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={dialogloading}
        onClose={handleCloseLoading}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <ReactLoading color="blue" height={50} width={50} type="spokes" />
      </Dialog>
    </div>
  );
}
